import React, { useState } from "react";
import SharedHelmet from "../Helmet";
const TITLE = "تحويل الوحدات - أداة شاملة لتحويل كافة الوحدات بدقة";
const DESCRIPTION =
  "حوّل بين مختلف الوحدات بسهولة باستخدام أداة تحويل الوحدات الشاملة. توفر دقة وسرعة في تحويل القياسات من وحدات مختلفة، مما يجعلها مثالية لجميع احتياجات القياس.";
const KEYWORDS =
  "تحويل الوحدات, محول الوحدات, حاسبة تحويل الوحدات, أدوات قياس, تحويل قياسات";
const OG_URL = "https://do-calculate.com/calculator/ar/unit_converter/length/";
const lengthParameters = {
  m: "متر",
  km: "كيلومتر",
  cm: "سنتيمتر",
  mm: "ميليمتر",
  mcm: "مايكرومتر",
  nm: "نانومتر",
  mile: "ميل",
  yard: "ياردة",
  foot: "قدم",
  inch: "بوصة",
  lightyear: "سنة ضوئية",
};
const lengths = Object.keys(lengthParameters);
function UnitsList() {
  const [searchTerm, setSearchTerm] = useState("");
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  const renderTable = (parameters, parameterNames) => (
    <table >
      <thead>
        <tr>
          <th >من الوحدة</th>
          <th >إلى الوحدة</th>
          <th >رابط الحاسبة</th>
        </tr>
      </thead>
      <tbody>
        {parameters
          .filter((fromParams) =>
            parameterNames[fromParams].includes(searchTerm)
          )
          .map((fromParams) =>
            parameters.map((toParams) => {
              if (fromParams !== toParams) {
                const url = `/calculator/ar/unit_converter/length/${fromParams}/${toParams}/`;
                return (
                  <tr key={`${fromParams}-${toParams}`}>
                    <td>{parameterNames[fromParams]}</td>
                    <td>{parameterNames[toParams]}</td>
                    <td>
                      <a href={url}>
                        تحويل من {parameterNames[fromParams]} إلى{" "}
                        {parameterNames[toParams]}
                      </a>
                    </td>
                  </tr>
                );
              }
              return null;
            })
          )}
      </tbody>
    </table>
  );
  return (
    <div>
      <div className="container rtl-container">
        <SharedHelmet
          TITLE={TITLE}
          DESCRIPTION={DESCRIPTION}
          KEYWORDS={KEYWORDS}
          OG_URL={OG_URL}
        />
        <div>
          <h1 style={{ fontSize: "26px" }}>{TITLE}</h1>
          <hr />
          <div className="alert alert-secondary" role="alert">
            <p>{DESCRIPTION}</p>
          </div>
        </div>
        <hr />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: "15px",
          }}
        >
          <h2 style={{ margin: 0 }}>الطول</h2>
          <input
            type="text"
            placeholder="ابحث عن وحدة..."
            value={searchTerm}
            onChange={handleSearchChange}
            style={{
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              width: "200px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          />
        </div>
        {renderTable(lengths, lengthParameters)}
        <br />
      </div>
    </div>
  );
}
export default UnitsList;
